import { render, staticRenderFns } from "./SellersStoreSelect.vue?vue&type=template&id=4dd9d04a&scoped=true&"
import script from "./SellersStoreSelect.vue?vue&type=script&lang=js&"
export * from "./SellersStoreSelect.vue?vue&type=script&lang=js&"
import style0 from "./SellersStoreSelect.vue?vue&type=style&index=0&id=4dd9d04a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd9d04a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/runner/work/kontalk/kontalk/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib'
installComponents(component, {VAutocomplete})
